import { useEffect, useState } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navigation from "./common/navigation/Navigation";
import Topheader from "./common/topheader/Topheader";
import Home from "./pages/home/Home";
import Blog from "./pages/blog/Blog";
import Footer from "./common/footer/Footer";
import ContactUS from "./pages/contactus/ContactUS";
import Social from "./common/social/Social";
import CSR from "./pages/csr/CSR";
import AboutUs from "./pages/aboutus/AboutUs";
import Media from "./pages/media/Media";
import SolarPlants from "./pages/solarplants/SolarPlants";
import TermsAndConditions from "./component/tandc/TermConditions";
import TopConSolar from "./pages/topconsolar/TopConSolar";
import QualityCertificate from "./pages/qcertificate/QualityCertificate";
import MonoPerc from "./pages/MonoPerc/MonoPerc";
import ContactBox from "./component/enquiry/ContactBox";
import Policy from "./component/privacy/Policy";
import CookieConsent from "./common/cookieconsent/CookieConsent";
import { ContextAPI } from "./ContextAPI/ContextAPI";
import Read from "./component/readmore2/Read";
import KusumYojna from "./pages/PMKusumYojna/KusumYojna";
import { getUTMParams } from "./utils/GetUtm";
// import Popup from "./pages/Popup";
import WhitePaper from "./pages/whitepaper/WhitePaper";
import EsgCom from "./pages/ESGCompliance/EsgCom";
  // import Rei from "./pages/Rei/Rei";

// import ReadMor from "./component/readmore4/readmor";
function App() {
  const { data } = ContextAPI();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const utm = getUTMParams();
    localStorage.setItem("utm_data", JSON.stringify(utm));

    const handleContextmenu = (e) => {
      e.preventDefault();
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    document.addEventListener("contextmenu", handleContextmenu);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("contextmenu", handleContextmenu);
    };
  }, []);

  return (
    <>
      {/* <Popup /> */}
      <Router>
        <>
          <header style={{ position: "sticky", top: 0, zIndex: "100" }}>
            <Topheader />
            <Navigation />
          </header>

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/esg" element={<EsgCom />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/contactus" element={<ContactUS />} />
            <Route path="/csr" element={<CSR />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/media" element={<Media />} />
            <Route path="/solarplants" element={<SolarPlants />} />
            <Route path="/topcon" element={<TopConSolar />} />
            <Route path="/mono" element={<MonoPerc />} />
            <Route path="/terms" element={<TermsAndConditions />} />
            <Route path="/policy" element={<Policy />} />
            <Route path="/quality" element={<QualityCertificate />} />
            <Route path="/contactbox" element={<ContactBox />} />
            <Route path="/kusum" element={<KusumYojna />} />
            <Route path="/whitepaper" element={<WhitePaper />} />
            {/* <Route path="/rei" element={<Rei/>}/> */}

            {/* <Route path="/read" element={<Read />} /> */}
            <Route path="/:slug" element={<Read />} />
            {data.map((el, index) => (
              <Route key={index} path={el.UUID} element={<Read Cards={el} />} />
            ))}
          </Routes>
          <Footer />
          <CookieConsent />
        </>
      </Router>

      <div
        style={{
          position: "fixed",
          bottom: "29px",
          right: "20px",
          zIndex: 9999,
          background: "white",
          borderRadius: "100px",
        }}
      >
        <img
          src="/KIWI_LOGO.png"
          alt="Kiwa"
          style={{
            width: isMobile ? "100px" : "170px",
          }}
        />
      </div>
      <Social />
    </>
  );
}

export default App;
